var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bodyWrapper"}},[_c('the-header',{attrs:{"tour":""}}),_c('the-drawer'),_vm._t("default"),_c('the-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }